<template>
	<div class="row">
		<div class="pdfViewer col-12" v-if="pdfUrl">
			<div class="text-center">
				<iframe class="pdf-page" :src="pdfUrl" id="pdfIframe" name="pdfIframe"></iframe>
			</div>
		</div>
		<div class="col-12 text-center center-flex" v-if="!pdfUrl">
			<h1 v-if="message">{{ t(this.message, this.message) }}</h1>
			<h1 v-else>{{ t('viewDocNoFileLoaded', 'viewDocNoFileLoaded') }}</h1>
		</div>
		<div class="overlay" v-if="overlayActive">
			<loading
				id="widget-loading-spinner"
				class="align-items-center"
				:color="'#047bf8'"
				:loader="'spinner'"
				:active="overlayActive"
				:transition="'fade'"
				:is-full-page="false">
			</loading>
		</div>
	</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import pdf from 'vue-pdf'
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import Loading from 'vue-loading-overlay'
import { backendUrl } from '@/helpers/backendUrl.js'

export default {
	name: 'HashDocumentView',
	components: {
		Navbar,
		pdf,
		Loading
	},
	data() {
		return {
			src: null,
			response: null,
			overlayActive: false,
			pdfUrl: '',
			message: null
		}
	},
	methods: {
		getFileData() {
      let data = {}
      data.doc_id = this.$route.params.doc_id
      data.token = this.$route.params.token
	    this.overlayActive = true

      if(!data.token) {
        this.message = 'missingDocumentAccessToken'
        this.pdfUrl = false
        this.overlayActive = false
      } else if(!data.doc_id) {
        this.message = 'missingDocumentAccessId'
        this.pdfUrl = false
        this.overlayActive = false
      } else {
        this.overlayActive = false
        this.pdfUrl = backendUrl() + '/getHashedDocumentData/' + data.doc_id + '/' + data.token
      }
		}
	},
	created(){
		this.getFileData()
		document.getElementsByTagName('body')[0].style.overflow = 'hidden'
	},
	computed: {
		...mapGetters(['getUserLevel']),
		clientName() {
			let clientName = clientShortName()
			return clientName
		},
		docId() {
			return this.$route.params.id
		},
		docType() {
			return this.$route.params.type
		},
		docInfo() {
			return this.$store.getters['documentsStore/getDocumentInfo']
		}
	}
}

</script>

<style scoped>

[v-cloak] {
	display: none !important;
}

.overlay {
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background-color: #5c5c5c;
	position: fixed;
	z-index: 000;
}

.pdf-page {
	display: inline-block;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	height: 100vh;
	padding: 0px;
}

.center-flex {
	display: flex;
	justify-content: center;
	align-items: center;
}

</style>
